import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { IUser } from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { getDisplayName } from '../../../../../models/NameUtils';
import { Checkbox } from '../../../../../web/components/Checkbox';
import { baseStyleSheet } from '../../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps extends IEventLoggingComponentProps {
	className?: string;
	styles?: StyleDeclarationValue[];
	user: IUser;
	selectedUsers: IUser[];
	setSelectedUsers: (users: IUser[]) => void;
}

const _BulkEmailApprovalUsersSelectRow: React.FC<IProps> = ({
	className,
	selectedUsers,
	setSelectedUsers,
	styles,
	user,
}) => {
	const onSelectionChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.checked) {
			setSelectedUsers([...selectedUsers, user]);
		} else {
			setSelectedUsers(selectedUsers.filter(x => x.id !== user.id));
		}
	};

	const email = user.primaryEmail?.value || '';

	return (
		<li
			className={`${css(styleSheet.container, ...(styles || []))} bulk-email-approval-user-select-row ${
				className || ''
			}`}
		>
			<Checkbox
				checked={selectedUsers.includes(user) || false}
				className={css(styleSheet.container, styleSheet.radioButton)}
				id={`bulk-email-approval-user-select-${user.id}`}
				name='bulk-email-approval-user-select'
				onChange={onSelectionChanged}
			>
				<div className={css(styleSheet.content)}>
					<div className={css(baseStyleSheet.truncateText, styleSheet.name)} title={getDisplayName(user)}>
						{getDisplayName(user)}
					</div>
					<div className={css(styleSheet.email)} title={email}>
						<span>(</span>
						<div className={css(baseStyleSheet.truncateText)}>{email}</div>
						<span>)</span>
					</div>
				</div>
			</Checkbox>
		</li>
	);
};

const BulkEmailApprovalUsersSelectRowAsObserver = observer(_BulkEmailApprovalUsersSelectRow);
const BulkEmailApprovalUsersSelectRowWithContext = inject()(BulkEmailApprovalUsersSelectRowAsObserver);
export const BulkEmailApprovalUsersSelectRow = withEventLogging(
	BulkEmailApprovalUsersSelectRowWithContext,
	'BulkEmailApprovalUsersSelectRow'
);
